import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { activeNote, startDeleting } from '../../actions/notes';
import { useForm } from '../../hooks/mis-custom-hooks/useForm/useForm';
import { NotesAppbar } from './NotesAppbar'
import {House} from '../../assets/House';

export const NoteScreen = () => {
    const dispatch = useDispatch();
    const {active:note} = useSelector( state => state.notes );

    const [formValues, handleInputChange, reset] = useForm(note)

    const {body,title} = formValues;
     
    const activeId = useRef(note.id)
    useEffect(() => {
        if (note.id !== activeId.current){
            reset(note)
            activeId.current = note.id
        }
    }, [note,reset])
   
    //Cuando cambie la nota quiero que se refleje en redux
    useEffect(() => {
        dispatch(activeNote(formValues.id,{...formValues}))
    }, [dispatch,formValues])

    const handleDelete = () =>{
        dispatch(startDeleting(note.id));
    }
    
    return (
        <div className="notes__main-content">
            <NotesAppbar/>
            <div className="notes__content">
                <input
                name='title'
                type="text"
                placeholder="Some awesome title"
                className="notes__title-input"
                autoComplete="off"
                value={title}
                onChange={handleInputChange}
                />

                <textarea
                name='body'
                placeholder="What happened today"
                className="notes__textarea"
                value={body}
                onChange={handleInputChange}
                >
                    
                </textarea>
                {
                (note.url) &&    
                <div className="notes__image">
                    <img 
                    src={`${note.url}`}
                    alt="imagen"
                    /> 
                </div>
                }
                <House/>
            </div>
            <button className="btn btn-danger" onClick = {handleDelete}>
                Delete
            </button>
        </div>
    )
}
